import { useEffect, useState } from "react";
import CreateForm from "components/Form/CreateForm/CreateForm";
import formFields from "./formFields.json";
import ProfilePage from "pages/Profile/ProfilePage";
import Button from "components/Buttons/Button/Button";
import useAPI from "hooks/useAPI";
import { useQuery } from "react-query";
import { GlobalQueries } from "hooks/useRefreshQuery";
import scss from "./NewReclamation.module.scss";
import { toast } from "react-toastify";
import AdditionalSection from "./AdditionalSection";
import { useTranslation } from "react-i18next";
import { printError } from "../../../../helpers/apiError";
import { useNavigate } from "react-router-dom";
import Empty from "components/Empty/Empty";

const NewReclamation = ({ reclamations }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const api = useAPI();
    const apiBasic = "reclamations/new/customer-data";

    const [loading, setLoading] = useState(false);

    const initItems = {
        id_order: null,
        order_slug: null,
        order_date: null,

        id_order_item: null,
        id_product: null,
        product_sinhro_id: null,

        fiscal_clip: null,
        fiscal_clip_date: null,

        product_sku: null,
        product_name: null,

        description: null,
        responsive_type: null,
        file: [],
    };
    const [itemsArray, setItemsArray] = useState([initItems]);

    const { data: companyDataBasic, isLoading: isCompanyDataBasicLoading } = useQuery([GlobalQueries.Profile.Reclamations], () => api.get(`${apiBasic}`));

    const { data: config } = useQuery(["reclamationsNewConfig"], () => api.get("/options/profile-page/reclamations/config"));
    const { data: receiptsConfig } = useQuery(["reclamationsAllowedReceiptsConfig"], () => api.get("/options/reclamations/config"));
    const allowedReceipts = receiptsConfig?.allowed_receipts ?? "all";
    const canCreateReclamation = receiptsConfig?.active === "1";

    // Local state for the company
    const [company, setCompany] = useState();
    useEffect(() => {
        setCompany(companyDataBasic);
    }, [setCompany, companyDataBasic]);
    const submitHandlerValues = () => {
        setLoading(true);
        api.post(`/reclamations/new`, { items: itemsArray, customer_data: company })
            .then(() => {
                toast.success(t("global-message-successfully_saved"));
                setItemsArray([initItems]);
                navigate("/reklamacije");
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.warn(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };

    // order_date, product_name, product_sku, description -> id postoji
    // fiscal_clip, fiscal_clip_date, product_name, product_sku, description -> id ne postoji
    const addAdditionalSection = () => {
        let lastItem = itemsArray[itemsArray.length - 1];
        if (lastItem?.product_name && lastItem?.product_sku && lastItem?.description !== "" && lastItem?.responsive_type?.length > 0) {
            if (lastItem?.id_order) {
                if (lastItem?.order_date) {
                    setItemsArray((prevSections) => [...prevSections, initItems]);
                } else {
                    toast.warn(t("reclamations-default-messages-fill_required_fields"));
                }
            } else {
                if (lastItem?.fiscal_clip && lastItem?.fiscal_clip_date) {
                    setItemsArray((prevSections) => [...prevSections, initItems]);
                } else {
                    toast.warn(t("reclamations-default-messages-fill_required_fields"));
                }
            }
        } else {
            toast.warn(t("reclamations-default-messages-fill_required_fields"));
        }
    };

    return (
        <>
            <ProfilePage>
                <div className={scss.header}>
                    <button type="button" className={scss.backButton} onClick={() => navigate("/reklamacije")} aria-label={t("global-default-text-Back")}>
                        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                            <path d="M15.5 10h-11m0 0 4.5-4.5M4.5 10l4.5 4.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <h4 className={scss.title}>{t("reclamations-new-title")}</h4>
                </div>
                {config && receiptsConfig && (config?.active !== "1" || !canCreateReclamation) && <Empty message={t("global-module_locked-title")} />}
                {company && config?.active === "1" && canCreateReclamation && (
                    <>
                        <CreateForm className={scss.customerForm} title={"reclamations-new-customer_information"} loading={loading} data={company} setData={setCompany} formFields={formFields} formButtons={false} />

                        <div className={`row ${scss.detailsForm}`}>
                            <h5>{t("reclamations-new-additional-title")}</h5>

                            {itemsArray?.map((item, index) => {
                                return (
                                    <AdditionalSection
                                        translateKey={"reclamations-new-additional"}
                                        index={index}
                                        key={index}
                                        item={item}
                                        itemsArray={itemsArray}
                                        allowedReceipts={allowedReceipts}
                                        onInitDataChange={(index, type, value) => {
                                            //type sta menjas
                                            // index koji element u nizu menjas
                                            // value vrednost elemnta koji menjas
                                            let arrOfState = [...itemsArray];
                                            let itemToChange = arrOfState[index];
                                            switch (type) {
                                                case "pretraga":
                                                    if (value?.id) {
                                                        itemToChange.id_order = value?.id;
                                                        itemToChange.order_slug = value?.slug;
                                                        itemToChange.order_date = value?.created_at;
                                                        itemToChange.fiscal_clip = null;
                                                        itemToChange.fiscal_clip_date = null;
                                                        itemToChange.product_sku = null;
                                                        itemToChange.product_name = null;
                                                    } else {
                                                        itemToChange.id_order = null;
                                                        itemToChange.order_slug = null;
                                                        itemToChange.order_date = null;
                                                        itemToChange.id_order_item = null;
                                                        itemToChange.id_product = null;
                                                        itemToChange.product_sinhro_id = null;
                                                        itemToChange.product_name = null;
                                                        itemToChange.product_sku = null;
                                                        itemToChange.fiscal_clip = value.fiscal_clip;
                                                    }
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "date":
                                                    itemToChange.fiscal_clip_date = value;
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "product_sku":
                                                    itemToChange.product_sku = value;
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "product_name":
                                                    itemToChange.product_name = value;
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "description":
                                                    itemToChange.description = value;
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "product":
                                                    const { id, id_product, sinhro_id, name, sku } = value;
                                                    itemToChange.id_order_item = id;
                                                    itemToChange.id_product = id_product;
                                                    itemToChange.product_sinhro_id = sinhro_id === null ? sinhro_id : String(sinhro_id);
                                                    itemToChange.product_name = name;
                                                    itemToChange.product_sku = sku;
                                                    arrOfState[index] = itemToChange;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "nema_proizvoda":
                                                    let arr = [...itemsArray];
                                                    setItemsArray(arr.slice(0, index));
                                                    toast.warn(t("reclamations-default-messages-no_product_to_reclamation"));
                                                    break;
                                                case "responsive_type":
                                                    let mapped = value.map((item, i) => {
                                                        return { id: item, name: item };
                                                    });
                                                    itemToChange.responsive_type = mapped;
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "file":
                                                    let mappedFile = value.map((item, i) => {
                                                        return item?.base_64;
                                                    });
                                                    itemToChange.file = [...mappedFile];
                                                    setItemsArray(arrOfState);
                                                    break;
                                                case "ukloni":
                                                    if (index === 0) {
                                                        let arr = [{ ...initItems }];
                                                        setItemsArray(arr);
                                                    } else {
                                                        let tempArr = [...itemsArray];
                                                        setItemsArray(tempArr.slice(0, index));
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }}
                                    />
                                );
                            })}

                            {/* <Button
                        label={"reclamations-new-additional-button-additional_reclamation_item"}
                        onClick={addAdditionalSection}
                        buttonStyleBasic={{ width: "100%", justifyContent: "center", marginTop: "2rem" }}
                    /> */}
                            <div className={scss.actions}>
                                <Button label={"reclamations-new-additional-button-submit"} onClick={submitHandlerValues} loading={loading} className={scss.primaryButton} />
                            </div>
                        </div>
                    </>
                )}
            </ProfilePage>
        </>
    );
};

export default NewReclamation;
